import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ContentWithHeader extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.text', '');
  }

  get contentItems() {
    return get(this, '_content_items', []);
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ContentWithHeader.model.js